export const services = [
    {
        icon_name: 'bi bi-display-fill',
        title: 'Web Development',
        description:
            "Développement d'applications et sites web modernes, rapides et évolutifs avec des technologies fiables et une architecture propre.",
    },
    {
        icon_name: 'bi bi-phone-fill',
        title: 'Mobile Development',
        description:
            "Création d'applications mobiles performantes pour Android et multiplateformes, centrées sur l'expérience utilisateur.",
    },
    {
        icon_name: 'bi bi-pc-display',
        title: 'Desktop Development',
        description:
            'Applications desktop robustes et légères pour automatiser les tâches et améliorer la productivité.',
    },
    {
        icon_name: 'bi bi-shield-lock-fill',
        title: 'Cybersecurity',
        description:
            'Sécurisation des applications, analyse des vulnérabilités et mise en place de bonnes pratiques pour protéger les données.',
    },
    {
        icon_name: 'bi bi-cpu-fill',
        title: 'Artificial Intelligence',
        description:
            "Intégration de solutions basées sur l'IA pour automatiser, analyser et améliorer les performances des systèmes.",
    },
];

export const projects = [
    {
        title: 'ICPRD',
        description:
            "Un site conçu pour autonomiser les communautés locales et favoriser l'harmonie régionale à travers le dialogue et le développement durable.",
        tech: ['NextJs', 'Prisma', 'Postgres'],
        role: 'Full-Stack Developer',
        status: 'in-progress',
        demo: 'https://icprd.com',
        github: '#',
    },
    {
        title: 'SENTINEL-NET',
        description:
            "SentinelNet est une solution moderne d'audit réseau conçue pour simplifier la cartographie des actifs et l'évaluation de la surface d'attaque.",
        tech: ['Scapy', 'Socket', 'Customtkinter', 'Sqlite3'],
        role: 'Full-Stack Developer',
        status: 'done',
        demo: '#',
        github: 'https://github.com/Luckson-dev/sentinel-net',
    },
    {
        title: 'Monalina Website',
        description:
            'Le site officiel complet de Monalina, présentant ses services et actualités.',
        tech: ['Django', 'PostgreSql'],
        role: 'Full-Stack Developer',
        status: 'paused',
        demo: 'https://monalina-yz1q.onrender.com',
        github: '#',
    },
    {
        title: 'Gestion de Stock',
        description:
            'Application de gestion pour faciliter la vente et la mise en oeuvre de bien et services.',
        tech: ['Django', 'PostgreSql'],
        role: 'Full-Stack Developer',
        status: 'done',
        demo: '',
        github: 'https://github.com/Wilondja243/system-de-stock',
    },
    {
        title: 'OpenHouse',
        description:
            'Un réseau social public, ouvert et visible pour tout le monde.',
        tech: ['Django DRF', 'PostgreSql', 'React Native'],
        role: 'Full-Stack Developer',
        status: 'in-progress',
        demo: '#',
        github: 'https://github.com/Wilondja243/open-house',
    },
    {
        title: 'DealFlow',
        description: 'Application de gestion et de prospection commerciale',
        tech: ['Django', 'PostgreSql'],
        role: 'Full-Stack Developer',
        status: 'paused',
        demo: 'https://deal-flow.onrender.com',
        github: 'https://github.com/Wilondja243/deal-flow',
    },
    // {
    //     title: 'JobBoard',
    //     description:
    //         'Prototype de système de gestion de bord, créé en collaboration avec mes stagiaires.',
    //     tech: ['Django', 'SQLite3'],
    //     role: 'Full-Stack Developer',
    //     status: 'paused',
    //     demo: '#',
    //     github: 'https://github.com/Wilondja243/jobBoard',
    // },
    {
        title: 'CodePlatform',
        description:
            'Plateforme de formation en ligne pour débutants en technologies.',
        tech: ['Django & PostGreSQL', 'React'],
        role: 'Full-Stack Developer',
        status: 'in-progress',
        demo: 'https://codeplatform-fawn.vercel.app/',
        // github: 'https://github.com/Wilondja243/codeplatform',
    },
    {
        title: 'Text Generator',
        description:
            'Text Generator est un projet éducatif développé de A à Z avec PyTorch.',
        tech: ['Python', 'Pytorch'],
        role: 'AI Developer',
        status: 'paused',
        demo: '',
        github: 'https://github.com/Wilondja243/text-generator',
    },
];
